
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect, useMemo } from 'react';
import { css } from '@emotion/react';
import type { NextPage } from 'next';
import { withOnboardingPageWrapper } from '@/components/OnboardingPageWrapper/OnboardingPageWrapper';
import { DownloadAppsStepInfo, FocusAreaStepInfo } from '@/components/Steps';
import { isAutomaticTrackingMode } from '@/components/Steps/InviteTeamStep/inviteAccessLevels.util';
import { withInviteStepCopy } from '@/components/Steps/InviteTeamStep/resolveInviteStepCopy.util';
import { getGrowthBookFeatures } from '@/context/Growthbook';
import { defaultFlowModel } from '@/features/default-flow/models/default-flow.model';
import { useAppSelector } from '@/hooks';
import { Step } from '@/shared/Step';
import { breakPtDown } from '../../emotion.definitions';
import { withAuthGuard } from '../guards/AuthGuard';
import { withFlowGuard } from '../guards/FlowGuard';
import { withOnboardingGuard } from '../guards/OnboardingGuard';
import { StepTypes } from '../types';
const styles = {
    Root: css `
    --main-modal-gutter: 40px;
    --progress-bar-mb: 40px;
    --step-info-max-width: 610px;
    --step-header-mb: 32px;

    ${breakPtDown.sm} {
      --main-modal-gutter: 16px;
    }
  `,
};
export const getStep = <T extends StepTypes>(stepKey: keyof T | undefined) => {
    // Get the current steps dynamically to reflect any changes in conditions
    const steps = defaultFlowModel.getSteps();
    // Check if the stepKey is DownloadAppsStepInfo.id and if it's not already in the list
    if (stepKey === DownloadAppsStepInfo.id && !steps.some(step => step.id === DownloadAppsStepInfo.id)) {
        // Create a new array with the additional step instead of modifying the original
        return DownloadAppsStepInfo;
    }
    // Return the found step or fall back to FocusAreaStepInfo
    return steps.find(step => step.id === stepKey) || FocusAreaStepInfo;
};
export const HomePageContent: NextPage = () => {
    const stepId = useAppSelector(state => state.onboarding.currentStep.id);
    const trackingMode = useAppSelector(state => state.onboarding.trackingMode);
    const trackingModeStep = useAppSelector(state => state.onboarding.trackingModeStep);
    const customTrackingModeStep = useAppSelector(state => state.auth.company?.companySettings?.custom?.trackingModeStep);
    const isAutomaticTracking = isAutomaticTrackingMode(defaultFlowModel.trackingMode, trackingMode, trackingModeStep, customTrackingModeStep);
    const currentStep = useMemo(() => {
        const step = getStep(stepId);
        return withInviteStepCopy(step, isAutomaticTracking);
    }, [stepId, isAutomaticTracking]);
    const { Component: StepContent, ...restStepProps } = currentStep;
    useEffect(() => {
        const container = document.getElementById('onboarding-scroll-container');
        if (container) {
            container.scrollTop = 0;
        }
        else {
            window.scrollTo(0, 0);
        }
    }, [stepId]);
    return (<Step {...restStepProps}>
      <StepContent flow={defaultFlowModel}/>
    </Step>);
};
const getStaticProps = getGrowthBookFeatures;
const WithWrapper = withOnboardingPageWrapper(HomePageContent, {
    css: styles.Root,
    flow: defaultFlowModel,
    getStep,
});
const WithOnboardingGuard = withOnboardingGuard(WithWrapper);
const WithFlowGuard = withFlowGuard(WithOnboardingGuard);
const HomePage = withAuthGuard(WithFlowGuard);
export default HomePage;

    async function __Next_Translate__getStaticProps__1a0cf8b0050__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cf8b0050__ as getStaticProps }
  